import { AddContactToActivityBody, ContactBody, ContactView } from "@/types/contacts";
import { ListView } from "@/types/api";
import Vue from "vue";
import { ActionTree, GetterTree, MutationTree } from "vuex";

const initialState: ContactState = {
  team_members: [],
};

const getters: GetterTree<ContactState, RootState> = {
  team_members(state: ContactState): Contact[] {
    return state.team_members;
  },
};

const mutations: MutationTree<ContactState> = {
  RESET(state: ContactState) {
    state.team_members = [];
  },
  SET_TEAM_MEMBERS(state: ContactState, payload: Contact[]) {
    state.team_members = payload;
  },
  ADD_TEAM_MEMBER(state: ContactState, contact: Contact) {
    const index = state.team_members.findIndex((model: Contact) => model.id === contact.id);

    if (index === -1) {
      state.team_members.push(contact);
    } else {
      Vue.set(state.team_members, index, contact);
    }
  },
  DELETE_TEAM_MEMBER(state: ContactState, account_id: number) {
    state.team_members = state.team_members.filter((contact: Contact) => contact.id !== account_id);
  },
};

const actions: ActionTree<ContactState, RootState> = {
  getContacts({ rootState }, payload: { query?: { search: string }; group_id: number }) {
    return rootState.api
      .get(`groups/${payload.group_id}/contacts`, {
        params: payload.query,
        withCredentials: true,
      })
      .then((response: { data: ListView<ContactView>; total: number }) => {
        return Promise.resolve(response.data.items);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  create({ rootState }, payload: { body: ContactBody; group_id: number }) {
    return rootState.api
      .post(`groups/${payload.group_id}/contacts`, payload.body, {
        withCredentials: true,
      })
      .then((response: { data: ContactView }) => {
        return Promise.resolve(response.data);
      });
  },
  addContactToActivity(
    { rootState },
    payload: {
      activity_id: number;
      body: AddContactToActivityBody;
    },
  ) {
    return rootState.api.post(`activities/${payload.activity_id}/contacts`, payload.body, { withCredentials: true });
  },
  resendInvite({ commit, rootState }, payload: { activity_id: number; contact_id: number }) {
    return rootState.api
      .post(`activities/${payload.activity_id}/contacts/${payload.contact_id}/resend-invite`, payload, { withCredentials: true })
      .then((response: { data: void }) => {
        return Promise.resolve();
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  removeFromActivity({ rootState }, payload: { contact_id: number; activity_id: number }) {
    return rootState.api.delete(`activities/${payload.activity_id}/contacts/${payload.contact_id}`, {
      withCredentials: true,
    });
  },
  update({ rootState }, payload: { body: Partial<ContactBody>; id: number }) {
    return rootState.api
      .patch(`contacts/${payload.id}`, payload.body, {
        withCredentials: true,
      })
      .then((response: { data: ContactView }) => {
        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
